import { Tabs } from 'antd';
import TabPane from 'antd/lib/tabs/TabPane';
import React, { useEffect } from 'react'
import { useState } from 'react';
import { createCookie, readCookie } from '../../../../config/CookieScript';
import { setHeaderName } from '../../../../services/SetHeaderName';
import { AddMacrosAndMicros } from './components/AddMacrosAndMicros';
import { AddTags } from './components/AddTags';
import { IngredientsForm } from './components/IngredientsForm,';
import { IngredientsUnit } from './components/IngredientsUnit';
import { MacrosMicrosUnit } from './components/MacrosMicrosUnit';
import { MealTime } from './components/MealTime';
import { RecipeCategory } from './components/RecipeCategory';
import { RecipePhenoTypes } from './components/RecipePhenoTypes';
import { RecipeTypes } from './components/RecipeTypes';
import './style/Recipe.scss'

export const Recipe = () => {
    const [activeTab, setActiveTab] = useState('1')

    const manageTab = (tabKey) => {
        // setActiveTab(tabKey)
        createCookie('RecipeTabKey', tabKey)
    }

    useEffect(() => {
        setHeaderName("Recipe Master")
    }, []);
    
    return (
        <div className="recipe-master">
            <Tabs
                // defaultActiveKey="1"
                defaultActiveKey={readCookie('RecipeTabKey') || activeTab}
                onChange={(e) => manageTab(e)}
                // onChange={onChange}
                type="card"
                tabPosition='left'
            >
                <TabPane tab="Recipe category" key="1">
                    <RecipeCategory />
                </TabPane>
                <TabPane tab="Recipe types" key="2">
                    <RecipeTypes />
                </TabPane>
                <TabPane tab="Recipe Phenotype" key="3">
                    <RecipePhenoTypes />
                </TabPane>
                <TabPane tab="Meal Time" key="4">
                    <MealTime />
                </TabPane>
                <TabPane tab="Recipe Tags" key="5">
                    <AddTags />
                </TabPane>
                <TabPane tab="Macros & Micros" key="6">
                    <AddMacrosAndMicros />
                </TabPane>
                <TabPane tab="Ingredients Form" key="7">
                    <IngredientsForm />
                </TabPane>
                <TabPane tab="Ingredients Unit" key="8">
                    <IngredientsUnit />
                </TabPane>
                <TabPane tab="Macros Micros Unit" key="9">
                    <MacrosMicrosUnit />
                </TabPane>
            </Tabs>
        </div>
    )
}
